/*
 * Project: LegalPlace assistant
 * File: src/redux/actions/flat_ui.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

// the UI contains { uiid, id, section_id, parant_id, active, multiple, copy_nbr }

const F_UI_CREATE = 'CREATE_FLAT_UI_'; // creates new index in the flat UI table
const F_UI_CHECK = 'CHECK_F_UI_'; // check the existance of UI in the flat table
const F_UI_SET_ACTIVE = 'SET_ACTIVE_F_UI_'; // set the entry as active
const F_UI_IS_MULTIPLE = 'IS_MULTIPLE_F_UI_'; // check if theentry is multiple
const F_UI_COPY_NUMBER = 'COPY_NUMBER_F_UI_'; // get if it's a copy number or not
// ================================================================================
const F_UI_RADIO_ACTIVE = 'RADIO_ACTIVE_F_UI_';
// ===============================================================================
const REMOVE_DUPLICATE = 'REMOVE_DUPLICATE';

function createFUI(uiid, id, genre, sectionId, parentId, ui_parent = '') {
  return {
    type: F_UI_CREATE,
    uiid,
    ui_parent,
    id,
    genre,
    sectionId,
    parentId,
  };
}

function checkUI(uiid, id) {
  return {
    type: F_UI_CHECK,
    uiid,
    id,
  };
}

function checkRadio(uiid, check) {
  return {
    type: F_UI_RADIO_ACTIVE,
    uiid,
    check,
  };
}

function setActive(id, active) {
  return {
    type: F_UI_SET_ACTIVE,
    id,
    active,
  };
}

function setMultiple(id, genre, multiple) {
  return {
    type: F_UI_IS_MULTIPLE,
    id,
    genre,
    multiple,
  };
}

function setCopy(id, genre, copy) {
  return {
    F_UI_COPY_NUMBER,
    id,
    genre,
    copy,
  };
}


function checkUIExists(state = [], id, genre) {
  const uiInfo = [];
  state.forEach((idx) => {
    if (idx.id === id && idx.genre === genre) uiInfo.push(idx);
  });
  return uiInfo;
}

function checkUIExistsThunk(id, genre) {
  return (dispatch, getState) => {
    const uiInfo = [];
    getState().flat.forEach((idx) => {
      if (idx.id === id && idx.genre === genre) uiInfo.push(idx);
    });
    return uiInfo;
  };
}

function removeFlatDuplicate(dupIdx) {
  return {
    type: REMOVE_DUPLICATE,
    id: dupIdx,
  };
}


export {
  F_UI_CREATE,
  F_UI_CHECK,
  F_UI_SET_ACTIVE,
  F_UI_IS_MULTIPLE,
  F_UI_COPY_NUMBER,
  F_UI_RADIO_ACTIVE,
  REMOVE_DUPLICATE,
  createFUI,
  checkUI,
  setActive,
  setMultiple,
  setCopy,
  checkUIExists,
  checkUIExistsThunk,
  checkRadio,
  removeFlatDuplicate,
};



// WEBPACK FOOTER //
// ./src/redux/actions/flat_ui.js